import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {NGXLogger} from 'ngx-logger';
import {Observable} from 'rxjs';
import {ScgHttpWrapper} from '@app/core/injectables/scg-http-wrapper';
import {CookieService} from '@app/core/services/cookie.service';
import * as dayjs from 'dayjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private scgHttp: ScgHttpWrapper,
              private cookie: CookieService,
              private log: NGXLogger) {
  }


  public getCBInfo() {
    return this.scgHttp.get<{ any }>(environment.apiUrl + 'info/cbversion');
  }

  public getCCInfo() {
    return this.scgHttp.get<{ any }>(environment.apiUrl + 'info/ccversion');
  }

  public getWindowsUsers() {
    return this.scgHttp.get<{ any }>(environment.apiUrl + 'ccusers');
  }

  public setWindowsUser(user: any) {
    return this.scgHttp.post<any>(environment.apiUrl + 'ccusers/edit', user);
  }

  public daýsOfSerial() {
    return this.scgHttp.get<{ any }>(environment.apiUrl + 'licence/daysofserial');
  }

  public shutdownPC(deviceId?: string): Observable<any> {
    return this.scgHttp.withDevice(deviceId).get<{ any }>(environment.apiUrl + 'sse/shutdown');
  }

  public getScreenshotListCB(): Observable<any> {
    return this.scgHttp.get<{ any }>(environment.apiUrl + 'cbscreenshot/list');
  }

  public deleteScreenshotsCB(): Observable<any> {
    return this.scgHttp.get<{ any }>(environment.apiUrl + 'cbscreenshot/delete');
  }

  public getScreenshotListCC(): Observable<any> {
    return this.scgHttp.get<{ any }>(environment.apiUrl + 'screenshots/list');
  }

  public deleteScreenshotsCC(): Observable<any> {
    return this.scgHttp.get<{ any }>(environment.apiUrl + 'screenshots/delete');
  }

  public updateScreenshotsCC(): Observable<any> {
    return this.scgHttp.get<{ any }>(environment.apiUrl + 'sse/screenshotupdate');
  }

  public deleteUsedDevice(serial: string): Observable<any> {
    return this.scgHttp.get<{ any }>(environment.apiUrl + 'licence/deleteuseddevice/' + serial);
  }

  public needEmailConfirm(emailentry: string): Observable<EmailConfirm> {
    const postVal = {email: emailentry};
    return this.scgHttp.withoutSync().post<EmailConfirm>(environment.apiUrl + 'action/isemailconfirmed', postVal);
  }

  public recoverPassword(langId, user: string) {
    const postVal = {lang: langId, username: user};
    return this.scgHttp.withoutSync().post<any>(environment.apiUrl + 'login/PWChangeRequestGetToken', postVal);
  }

  public resetHackscreen(deviceId?: string) {
    return this.scgHttp.withDevice(deviceId).withoutSync().get<any>(environment.apiUrl + 'cbsync/resethackscreen');
  }

  public getLoginEmail() {
    return this.scgHttp.withoutSync().get<any>(environment.apiUrl + 'service/email');
  }

  public resetCBEntries(items) {
    return this.scgHttp.post<any>(environment.apiUrl + 'applist/cb-reset', items);
  }

  public resetCCCntries(username, items) {
    return this.scgHttp.post<any>(environment.apiUrl + username + '/applist/cc-reset', items);
  }

  public deleteAccount() {
    return this.scgHttp.get<any>(environment.apiUrl + 'action/deleteaccount');
  }

  public linkChecker(domain: string) {
    const postVal = {url: domain};
    return this.scgHttp.withoutSync().post<any>(environment.apiUrl + 'test/linkchecker', postVal);
  }


  public cbScreenshotInit() {
    return this.scgHttp.get<{ any }>(environment.apiUrl + 'cbscreenshot');
  }

  public getVersionHistory(lang) {
    return this.scgHttp.withoutSync().get<any>(environment.apiUrl + 'service/versionhistory/' + lang);
  }

  public getVersionHistoryByVersionType(kind: string, lang: string) {
    return this.scgHttp.withoutSync().get<any>(environment.apiUrl + 'service//versionhistory/' + kind + '/' + lang);
  }

  public getDebugAction(actionVal, debugpwVal, azDateVal) {
    const postVal = {action: actionVal, debugpw: debugpwVal, azdate: azDateVal};
    return this.scgHttp.withoutSync().post<any>(environment.apiUrl + 'debug', postVal);
  }

  public setParentsSettings(valParentsOrderView: number, valParentsDeviceView: number) {
    const postVal = {parentsOrderView: valParentsOrderView, parentsDeviceView: valParentsDeviceView};
    return this.scgHttp.withoutSync().post<any>(environment.apiUrl + 'parents/settings', postVal);
  }

  public getParentsSettings() {
    return this.scgHttp.withoutSync().get<any>(environment.apiUrl + 'parents/settings');
  }

  public getParentsDeviceList() {
    return this.scgHttp.withoutSync().get<any[]>(environment.apiUrl + 'parents/parentsdevicelist');
  }

  public deleteParentsDevice(pcId: string) {
    const postVal = {pcId};
    return this.scgHttp.withoutSync().post<any>(environment.apiUrl + 'parents/parentsdevicelist/delete', postVal);
  }

  public getDeviceList(filter: 'all' | 'active') {
    const postdata = {browsertime: dayjs().format('YYYY-MM-DD HH:mm:ss')};
    return this.scgHttp.withoutSync().post<any[]>(environment.apiUrl + 'device/list?filter=' + filter, postdata);
  }

  public getDeviceCard(username: string, deviceId?: string) {
    const postdata = {browsertime: dayjs().format('YYYY-MM-DD HH:mm:ss')};
    return this.scgHttp.withDevice(deviceId).withoutSync().post<any>(environment.apiUrl + 'device/card?username=' + username, postdata);
  }

  public getAllNotifications() {
    return this.scgHttp.get<any>(environment.apiUrl + 'notification/countall');
  }

  public getHasNotificationAny() {
    return this.scgHttp.get<any>(environment.apiUrl + 'notification/hasany');
  }

  public ignoreUpdate() {
    return this.scgHttp.get<any>(environment.apiUrl + 'action/ignoreupdate');
  }

  public eventLog(eventId: number) {
    const postVal = {id: eventId};
    return this.scgHttp.withoutSync().post<any>(environment.apiUrl + 'eventlog', postVal);
  }

  public getCoAccounts() {
    return this.scgHttp.get<any>(environment.apiUrl + 'account/coaccount');
  }

  public addCoAccount(loginVal: string, pwVal: string) {
    const postVal = {login: loginVal, pw: pwVal};
    return this.scgHttp.withoutSync().post<any>(environment.apiUrl + 'account/addcoaccount', postVal);
  }

  public deleteCoAccount(loginVal: string) {
    const postVal = {login: loginVal};
    return this.scgHttp.withoutSync().post<any>(environment.apiUrl + 'account/deletecoaccount', postVal);
  }

  public getWhatsNewList(langId: string) {
    const postVal = {lang: langId};
    return this.scgHttp.withoutSync().post<any>(environment.apiUrl + 'whatsnew', postVal);
  }

  public verifyLoginEmail(langId: string) {
    const postVal = {lang: langId};
    return this.scgHttp.withoutSync().post<any>(environment.apiUrl + 'account/verifyloginemail', postVal);
  }

  public verifyReportEmailCb(langId: string) {
    const postVal = {lang: langId};
    return this.scgHttp.withoutSync().post<any>(environment.apiUrl + 'account/verifyReportEmail', postVal);
  }

  public verifyReportEmailCc(username: string, langId: string) {
    const postVal = {lang: langId};
    return this.scgHttp.withoutSync().post<any>(environment.apiUrl + '/account/' + username + '/verifyReportEmail', postVal);
  }

  public isLoginEmailVerified() {
    return this.scgHttp.get<any>(environment.apiUrl + 'account/isLoginEmailVerified');
  }

  public isReportEmailVerfiedCb() {
    return this.scgHttp.withoutSync().get<any>(environment.apiUrl + 'account/isReportEmailVerified');
  }

  public isReportEmailVerfiedCc(username: string) {
    return this.scgHttp.withoutSync().get<any>(environment.apiUrl  + '/account/' + username + '/isReportEmailVerified');
  }

  public gpsLocationHistory(entries: number, langId: string) {
    const postVal = {maxEntries: entries, lang: langId};
    return this.scgHttp.withoutSync().post<any>(environment.apiUrl + '/cblocation/history', postVal);
  }

  public saveLocationHistory(latLon: string) {
    const postVal = {latLong: latLon};
    return this.scgHttp.withoutSync().post<any>(environment.apiUrl + '/cblocation/save', postVal);
  }

  public getLoginNotify() {
    return this.scgHttp.withoutSync().get<any>(environment.apiUrl  + '/account/loginnotify');
  }

  public setLoginNotify(status: boolean) {
    const postVal = {value: status};
    return this.scgHttp.withoutSync().post<any>(environment.apiUrl + '/account/loginnotify', postVal);
  }

  public getDateAlert() {
    return this.scgHttp.withoutSync().get<any>(environment.apiUrl  + '/account/datealert');
  }

  public setDateAlert(status: boolean) {
    const postVal = {value: status};
    return this.scgHttp.withoutSync().post<any>(environment.apiUrl + '/account/datealert', postVal);
  }


  // ================================ MFA / 2FA ================================
  // Die mfa/*-Endpoints liegen auf dem filterlosen loginController und loesen die Session MANUELL aus dem
  // X-sessionId-Header auf. Der globale AuthInterceptor behandelt jede api/login*-URL als Login/Logout und
  // setzt dort KEINE Auth-Header -> deshalb haengen wir X-sessionId hier explizit an (aus dem Session-Cookie).
  private mfaSessionOptions() {
    return {headers: {'X-sessionId': this.cookie.getCookie('sessionId') ?? ''}};
  }

  // Globaler 2FA-Kill-Switch (AppSetting Mfa.Enabled) — steuert, ob das Portal das 2FA-UI zeigt.
  // Kein Account-Zustand, keine Session noetig.
  public mfaFeatureEnabled(): Observable<MfaFeature> {
    return this.scgHttp.withoutSync().get<MfaFeature>(environment.apiUrl + 'login/mfa/feature');
  }

  public mfaStatus(): Observable<MfaStatus> {
    return this.scgHttp.withoutSync().get<MfaStatus>(environment.apiUrl + 'login/mfa/status', this.mfaSessionOptions());
  }

  public mfaSetup(): Observable<MfaSetup> {
    return this.scgHttp.withoutSync().post<MfaSetup>(environment.apiUrl + 'login/mfa/setup', {}, this.mfaSessionOptions());
  }

  // Zeigt den QR des bestehenden (aktiven) Secrets erneut (weiteres Gerät). Verlangt einen frischen Code,
  // bevor das Backend das Secret erneut offenlegt.
  public mfaQr(code: string): Observable<MfaSetup> {
    return this.scgHttp.withoutSync().post<MfaSetup>(environment.apiUrl + 'login/mfa/qr', {code}, this.mfaSessionOptions());
  }

  public mfaEnable(code: string): Observable<any> {
    return this.scgHttp.withoutSync().post<any>(environment.apiUrl + 'login/mfa/enable', {code}, this.mfaSessionOptions());
  }

  public mfaVerify(code: string): Observable<any> {
    return this.scgHttp.withoutSync().post<any>(environment.apiUrl + 'login/mfa/verify', {code}, this.mfaSessionOptions());
  }

  public mfaDisable(code: string): Observable<any> {
    return this.scgHttp.withoutSync().post<any>(environment.apiUrl + 'login/mfa/disable', {code}, this.mfaSessionOptions());
  }


}


export interface EmailConfirm {
  email?: string;
  level?: number;
}

export interface MfaFeature {
  enabled: boolean;
}

export interface MfaStatus {
  enabled: boolean;
  activatedAt: string;
}

export interface MfaSetup {
  otpauthUri: string;
}
